// Reusable search helper with a "related" fallback.
//
// Behaviour:
//   1. If the query is empty → return all items, fallback=false.
//   2. Exact substring match against the haystack → return those, fallback=false.
//   3. Otherwise split the query into 2+ char tokens and rank items by how many
//      tokens match. Returns the ranked non-zero list with fallback=true.
//   4. If even token search finds nothing, return ALL items with fallback=true
//      (the UI surfaces a "showing all — no match for …" hint).
//
// `getHay` is a function that turns an item into a single lowercase string.
export function searchWithFallback(items, q, getHay) {
  const needle = (q || "").trim().toLowerCase();
  if (!needle) return { items, fallback: false, empty: false };

  const haystacks = items.map((it) => getHay(it).toLowerCase());

  const exact = items.filter((_, i) => haystacks[i].includes(needle));
  if (exact.length > 0) return { items: exact, fallback: false, empty: false };

  const tokens = needle.split(/\s+/).filter((t) => t.length >= 2);
  if (tokens.length === 0) {
    return { items, fallback: true, empty: true };
  }

  const scored = items
    .map((it, i) => {
      const hay = haystacks[i];
      const score = tokens.reduce((s, t) => s + (hay.includes(t) ? 1 : 0), 0);
      return { it, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((x) => x.it);

  if (scored.length > 0) return { items: scored, fallback: true, empty: false };
  return { items, fallback: true, empty: true };
}
